"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, forwardRef } from "@chakra-ui/react";
import { ButtonCardSize } from "./ButtonCard.types";
import Button from "../Button/Button";
import { Text } from "../Text";
import { SvgSpriteConsumer } from "../SvgSprite";
import { ButtonVariant } from "../Button/Button.types";
const ButtonCard = forwardRef((_a, ref) => {
    var { label, iconId, disabled, size = ButtonCardSize.LG, variant = ButtonVariant.SECONDARY_OUTLINED } = _a, rest = __rest(_a, ["label", "iconId", "disabled", "size", "variant"]);
    return (_jsx(Button, Object.assign({ ref: ref, variant: variant, isDisabled: disabled, border: variant === ButtonVariant.SECONDARY_OUTLINED ? "2px solid" : "none", h: size === ButtonCardSize.MD ? "64px" : "88px", w: "100%" }, rest, { children: _jsxs(Flex, Object.assign({ direction: "column", alignItems: "center", w: "100%" }, { children: [_jsx(SvgSpriteConsumer, { svgId: iconId, size: 24 }), _jsx(Text, Object.assign({ paddingTop: size === ButtonCardSize.MD ? 1 : 2, overflow: "hidden", textOverflow: "ellipsis", w: "100%", fontWeight: "core.demibold" }, { children: label }))] })) })));
});
export default ButtonCard;
//# sourceMappingURL=ButtonCard.js.map